document.addEventListener('alpine:init', () => {
Alpine.data(
  'pdpStickyColumn',
  (selectedVariantId, selectedVariantHandle = '') => ({
    selectedVariantId,
    selectedVariantHandle,
    buyLink: null,

    get ctaLabel() {
      return this.selectedVariantHandle.includes('48-hour')
        ? 'Try now'
        : 'Buy now';
    },

    selectVariant(variantId, buyLink, variantHandle) {
      this.selectedVariantId = variantId;
      this.buyLink = buyLink;
      this.selectedVariantHandle = variantHandle;
    },

    expiryLabel(qty, type) {
      if (!qty || !type) return '';

      const date = new Date();

      switch (type) {
        case 'days':
          date.setDate(date.getDate() + qty);
          break;
        case 'weeks':
          date.setDate(date.getDate() + qty * 7);
          break;
        case 'months':
          date.setMonth(date.getMonth() + qty);
          break;
        case 'years':
          date.setFullYear(date.getFullYear() + qty);
          break;
      }

      return `Expires: ${date.getDate().toString().padStart(2, '0')} ${
        date.toLocaleString(undefined, { month: 'long' })
      }, ${date.getFullYear()}`;
    },

    init() {
      console.log('Product section init:', this.selectedVariantId)
    },

  }))
})